import { makeStyles } from "@mui/styles";
import { color } from "framer-motion";
export const useStyle = makeStyles((theme) => ({
  datePicker: {
    // width: "80%",
    backgroundColor: "#fff",
    outline: "#CBCBCB",
    border: "none",
    borderRadius: "5px",
    // height: "40px",
  },
  btnKeys: {
    "&.MuiButton-root": {
      backgroundColor: "#fff",
      color: "#000",
      fontWeight: 500,
      textTransform: "capitalize",
      marginInlineEnd: "10px !important",
      boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
      border: "1px solid",
    },
  },

  tblRoot: {
    border: "1px solid #ddd",
    "&.MuiTableContainer-root": {
      // height: "370px",
      // overflowY: 'auto',
      // [theme.breakpoints.down(400)]: {
      //     maxHeight: "700px",
      //   },
      "&::-webkit-scrollbar": {
        width: "10px",
      },
      "&:hover::-webkit-scrollbar": {
        display: "block",
      },
      "&::-webkit-scrollbar-track": {
        backgroundColor: "rgba(230, 246, 240, 1)", // Track color
      },
      "&::-webkit-scrollbar-thumb": {
        backgroundColor: "rgba(203, 203, 203, 1)", // Thumb color
      },
    },
  },

  tblRow: {
    "&:hover": {
      backgroundColor: "#f5f5f5", // Optional: Change background color on hover
    },
    borderBottom: "1px solid #ddd", // Border for each table row
  },
  tblCell: {
    padding: "5px !important",
    borderRight: "1px solid #ddd",
    color: "rgba(36, 36, 36, 1) ",
    fontWeight: "500",
    fontSize: "14px !important",
  },
  amntWeight: {
    fontWeight: "700 !important",
  },
  tblHeadCell: {
    backgroundColor: "#A06EE1 !important",
    color:"#fff !important",
    fontWeight: "700 !important",
    padding: "8px !important",
  },
  title: {
    "&.MuiTypography-root": {
      color: "#fff",
      fontWeight: 700,
      textAlign: "right",
      [theme.breakpoints.down(900)]: {
        textAlign: "left",
      },
    },
  },
  dateField: {
    "&.MuiGrid-root": {
      display: "flex",
      justifyContent: "flex-end",
      [theme.breakpoints.down(900)]: {
        justifyContent: "flex-start",
        padding: "10px",
      },
    },
  },
  bags: {
    "&.MuiGrid-root": {
      [theme.breakpoints.down(900)]: {
        paddingTop: "10px",
      },
    },
  },
  keys: {
    "&.MuiGrid-root": {
      display: "flex",
      padding: "8px",
      [theme.breakpoints.down(900)]: { display: "flex" },
    },
  },
  tableAlignCenter: {
    textAlign: "center !important",
  },
  tblHeader: {
    "&.MuiTableHead-root": {
      "& .MuiTableCell-root": {
        fontWeight: 600,
        backgroundColor: "#A06EE1 !important",
        paddingBlock: "6px",
        color: "#fff",
        letterSpacing: 1,
      },
    },
  },
  tablrow: {
    "&.MuiTableRow-root": {
      "& .MuiTableCell-root": {
        textAlign: "center",
        padding: "0px",

      },
    },
  },
  tableAlignRight: {
    textAlign: "right !important",
    paddingInlineEnd: "10px !important",
  },
  rtlInput: {
    maxHeight: "20px",
    textAlign: "right", // Align the text to the right within the input
  },
  root: {
    display: "flex",
    flexDirection: "column",
    flex: 1,
    height: "calc(100% - 60px)",
  },
  counterGrid: {
    "&.MuiGrid-root": {
      backgroundColor: "#B74704",
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      padding: 1,
    },
  },
  counterTitle: {
    "&.MuiTypography-root": {
      color: "#fff",
      fontWeight: 700,
      marginRight: "5px",
    },
  },
  tableInput: {
    "&.MuiTextField-root": {
      "& .MuiOutlinedInput-root": {
        // backgroundColor:theme.palette.grey[50],
        "& fieldset": {
          // borderColor:theme.palette.grey[200],
          // borderWidth:'1.4px',
          border: "none",
        },
        // '&:hover fieldset': {
        //   borderColor:theme.palette.grey[200],
        //   border:'none',
        //   borderWidth:'1.4px',
        // },
        // '&:active fieldset': {
        //   // borderColor:theme.palette.grey[200],
        //   border:'none',
        //   borderWidth:'1.4px',
        // },
        "&.Mui-focused fieldset": {
          borderColor: theme.palette.grey[800],
          border: "none",
          borderWidth: "1.4px",
        },
      },
      "& .MuiInputBase-input": {
        color: theme.palette.grey[800],
        border: "none",
      },
      "& .MuiInputLabel-root": {
        color: theme.palette.grey[800],
        border: "none",
      },
    },
  },
  cashRoot: {
    "&.MuiGrid-root": {
      backgroundColor: "white",
      position: "relative",
      // width:'max-content'
      // maxWidth : 500
    },
  },
  cashRootMember: {
    "&.MuiGrid-root": {
      width: "fit-content",
      // height: "100%",
      backgroundColor: "white",
      padding: "10px",
      position: "relative",
    },
  },
  cashGrid: {
    "&.MuiGrid-root": {
      paddingInline: "8px",
      // maxHeight: "60dvh",

      "&::-webkit-scrollbar": {
        display: "none",
      },
    },
  },
  titleCashClose:{
    "&.MuiTypography-root":{
        color:"#A06EE1",
        fontWeight:600,
        fontSize:22
    }
  },
  cashTitle: {
    "&.MuiGrid-root": {
      backgroundColor: "#A06EE1",
      height: "100%",
      "& .MuiTypography-root": {
        color: "#fff",
        fontSize: "20px",
        fontWeight: 700,
        width: "100%",
        textAlign: "center",marginBlockEnd:1
      },
      "& .MuiIconButton-root": {
        position: "absolute",
        top: -5,
        right: 0,
        color: "#000",
      },
    },
  },
  subTitle: {
    "&.MuiTypography-root": {
      fontWeight: 600,
      fontSize: 16,
    },
  },
  subAmt: {
    "&.MuiTypography-root": {
      color: "rgba(9, 9, 105, 1)",
      fontWeight: 700,
      fontSize: 20,
      textAlign: "right",
    },
  },
  flexCorrection: {
    "&.MuiGrid-root": {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      marginBlock:3
    },
  },
  TextFieldCash:{
    "&.MuiTextField-root":{
      color: "#fff !important",
      borderRadius: "0px",
      maxWidth:"180px",
      marginInlineStart:"20px",
      '& .MuiOutlinedInput-root': { 
      '&:hover': {
          '& .MuiOutlinedInput-notchedOutline': {
              borderWidth: '0px', 
          }
          },
      '&.Mui-focused': {
          outline: 'none', 
          '& .MuiOutlinedInput-notchedOutline': {
          borderWidth: '0px', 
          }
      },
      '& .MuiOutlinedInput-notchedOutline': {
          borderWidth: '0px', 
      }
      }
    }
  },
  tblRoot: {
    "&.MuiTableContainer-root": {
      // height: "100%",
      "&::-webkit-scrollbar": {
        width: "10px",
      },
      "&:hover::-webkit-scrollbar": {
        display: "block",
      },
      "&::-webkit-scrollbar-track": {
        backgroundColor: theme.palette.grey[100],
      },
      "&::-webkit-scrollbar-thumb": {
        border: "2px solid #A9A9A9",
        borderRadius: "20px",
        backgroundColor: theme.palette.common.white,
        backgroundClip: "content-box",
      },
    },
  },
  table: {
    position: "relative",
    // outline: `0.5px solid #ccc`,
    borderRadius: "4px",
  },
  tablrow: {
    "&.MuiTableRow-root": {
      "& .MuiTableCell-root": {
        textAlign: "center",
        padding: "5px",
        borderRight: `1px solid #ccc`,
      },
    },
  },
  tblHeader: {
    "&.MuiTableHead-root": {
      "& .MuiTableCell-root": {
        fontWeight: 600,
        backgroundColor: "#ba68c8",
        paddingBlock: "6px",
        color: "#fff",
        letterSpacing: 1,
      },
    },
  },
  fieldBox: {
    "&.MuiTextField-root": {
      height: "20px",
      backgroundColor: "red",
    },
  },
  tblContentCell: {
    "&.MuiTableCell-root": {
      textAlign: "center",
      padding: "0px",
      borderBottom:'0.5px solid  #ccc',
      "& .MuiTextField-root": {
        textAlign:"center",
        "& .MuiOutlinedInput-root": {
          height: 30,
          padding: 0,
          // backgroundColor: theme.palette.grey[50],
          "& fieldset": {
            borderColor: "#fff",
            borderWidth: "1.4px",
          },
          "&:hover fieldset": {
            borderColor: "#fff",
            borderWidth: "1.4px",
          },
          "&.Mui-focused fieldset": {
            borderColor: "#fff",
            borderWidth: "1.4px",
          },
        },
      },
      // border: `1px solid #ccc`,
    },
    
  },
}));
